<script>

import {
  getInvoiceDetails,
  discountServiceList,
  getAvailableServiceList,
  topUp,
  createInvoice, getUserServiceList
} from "@/api/subscriptions";
import {search} from "@/api/organizations";


import * as organizationApi from '@/api/organizations';
import {mapActions, mapGetters} from "vuex";
import moment from "moment";

export default {
  name: 'SubscriptionPayPage',
  components: {},
  data() {

    this.setStep(2)

    let services = []

    let selected_services = []

    let discounts = []

    let active_services = []
    getUserServiceList().then(
        (response) => {
          this.active_services = [...response.data.active_services, ...response.data.awaiting_services]
        }
    )

    discountServiceList().then(
        (json) => {
          this.discounts = json.data.data.periods
          this.setDiscounts(json.data.data.periods)
        }
    )

    getAvailableServiceList().then(
        (json) => {
          this.services = json.data.data.services
        }
    )

    return {
      active_services: active_services,
      services: services,
      selected_services: selected_services,
      durations: [],
      organizations: [],
      query: '',
      discounts: discounts,


      createInvoice: false,
      withdraw: true,
      income_source: 'card',
      requisites: {},
      offers: [],
      need_search: false,
      formHasErrors: false,
      not_search: false,
      validates: {
        client_inn: true,
        client_bik: true,
        client_name: true,
        client_rs: true,
        client_ks: true,
        client_bank_name: true,
        client_legal_address: true,
      },
      invoice: {
        product_name: 'Оплата подписки',
        client_inn: '',
        client_bik: '',
        client_name: '',
        client_rs: '',
        client_ks: '',
        client_bank_name: '',
        client_legal_address: '',
        user_subscription_id: 0
      },
    }
  },

  mounted() {
    this.load();
  },

  computed: {
    ...mapGetters('subscription', [
      'isChecked',
      'isModalVisible',
      'getBusySlots',
      'getSlots',
      'getItemSlots',
      'isSlotPresented',
      'getStep',
      'getItems',
      'getState',
      'getServices',
      'getItemSlotsList',
      'getDiscount'
    ]),
    ...mapGetters('user', ['USER_ID']),
    ...mapGetters('workspace', ['ID_WORK_SPACE']),
    serviceNum() {
      return this.services.filter(service => this.isChecked(service.id)).length;
    },

    getSum() {
      return parseFloat(
          this.getServices().map(
              (service) => {

                let discount = (100 - this.getDiscount(service.id)) / 100;
                return service.price_per_unit ? service.price_per_unit * this.getItemSlotsList(service.id).duration * this.getSlots(service.id) * discount : 0;
              }
          ).reduce((acc, item) => acc + item, 0)
      )
    },
    getTotalSum() {
      return parseInt(
          this.getServices().map(
              (service) => {
                return service.price_per_unit ? parseInt(service.price_per_unit) * this.getItemSlotsList(service.id).duration * this.getSlots(service.id) : 0;
              }
          ).reduce((acc, item) => acc + item, 0)
      )
    }
  }
  ,
  methods: {
    ...mapActions('subscription', ['setSlots', 'hideModal', 'showModal', 'toggleItemSlot', 'setDiscounts', 'setStep', 'toggleService']),
    async load() {
      let response = await organizationApi.workspaceOrganizations(this.ID_WORK_SPACE);
      this.organizations = response.data.data.map(
          (item) => {
            return {
              id: item.id,
              name: item.short_name,
              inn: item.inn
            }
          }
      )

      await getInvoiceDetails().then(
          (json) => {
            this.requisites = json.data
            this.offers = json.data
          }
      )
    },
    getFinishDate(service) {
      const duration = this.getItemSlotsList(service.id).duration
      return this.getServiceStartDate(service.id).add(duration, 'M').format('D.MM.Y')
    },
    getStartDate(id) {
      return this.getServiceStartDate(id).format('D.MM.Y')
    },
    getServiceStartDate(id) {
      const index = this.active_services.map(param => param.service_id).lastIndexOf(id)
      if (this.active_services[index]) {
        if (moment(this.active_services[index].subscription_finish_date) > moment()) {
          return moment(this.active_services[index].subscription_finish_date, 'YYYY-MM-DD')
        }
      }
      return moment()
    },
    async createSubscription() {
      return 1
    },

    validate(name) {
      if (name === 'client_inn' && !this.not_search) {
        this.searchByInn()
      }
      if (this.$refs[name].validate()) {
        this.validates[name] = true
      } else {
        this.validates[name] = false
      }
    },

    searchInvoiceDetails() {
      this.offers = []
      this.need_search = true
      this.requisites.filter(
          (req) => {
            if (this.need_search && req.inn.startsWith(this.invoice.client_inn)) {
              this.offers.push(req)
            }
          }
      )

      if (this.offers.length === 0) {
        this.not_search = false
      }
    },

    searchByInn() {
      search({'inn': this.invoice.client_inn})
          .then(
              (json) => {
                this.invoice.client_name = ''
                this.invoice.client_legal_address = ''
                this.invoice.client_bik = ''
                this.invoice.client_rs = ''
                this.invoice.client_ks = ''
                this.invoice.client_bank_name = ''
                if (Object.keys(json.data).length !== 0) {
                  this.invoice.client_name = json.data.fullName
                  this.invoice.client_legal_address = json.data.address
                  this.invoice.client_bik = ''
                  this.invoice.client_rs = ''
                  this.invoice.client_ks = ''
                  this.invoice.client_bank_name = ''
                }
              }
          )
    },

    fill(offer) {
      this.not_search = true
      this.invoice.client_name = offer.name
      this.invoice.client_legal_address = offer.address
      this.invoice.client_inn = offer.inn
      this.invoice.client_bik = offer.bik
      this.invoice.client_rs = offer.checking_account
      this.invoice.client_ks = offer.corr_account
      this.invoice.client_bank_name = offer.bank_name
      this.offers = []
      this.need_search = false
      this.validates = {
        client_inn: true,
        client_bik: true,
        client_name: true,
        client_rs: true,
        client_ks: true,
        client_bank_name: true,
        client_legal_address: true,
      }
    },

    getInvoice() {
      this.formHasErrors = false
      console.log('Ok');
      Object.keys(this.invoice).forEach(f => {
        if (f && !this.invoice[f] && f !== 'discount' && f !== 'user_subscription_id') {
          console.log(f, this.invoice[f])
          console.log(f, true)
          this.formHasErrors = true
        }
        if (this.$refs[f]) {
          this.$refs[f].validate(true)
          if (!this.$refs[f].validate()) {
            this.validates[f] = false
            this.formHasErrors = true
            console.log(f, this.validates[f])
          } else {
            this.validates[f] = true
          }
        }
      })
      console.log(this.formHasErrors)
      if (!this.formHasErrors) {
        this.createInvoice = true
        console.log('step 3')
        this.invoice.services = this.getServices().map(
            (service) => {

              const full_amount = service.price_per_unit * this.getItemSlotsList(service.id).duration * this.getSlots(service.id)
              const discount_size = full_amount * this.getDiscount(service.id) / 100

              return {
                service_id: service.id,

                subscription_start_date: this.getStartDate(service.id),
                subscription_finish_date: this.getFinishDate(service),

                period: this.getItemSlotsList(service.id).duration,
                user_id: this.USER_ID,

                price_per_unit: service.price_per_unit,
                discount_size: discount_size,
                discount_percent: this.getDiscount(service.id),
                full_amount: full_amount,

                unit_count: this.getSlots(service.id)
              }
            }
        )
        createInvoice(
            this.invoice,
            parseInt(this.getSum),
            this.USER_ID
        ).then((response) => {
          console.log('step 4')
          this.$router.push({name: 'SubscriptionDownloadInvoice', params: {id: response.data.id}})
        })
      }
    },

    payWithCard() {

      const data = {
        source: 'card',
        amount: this.getSum,

        services: this.getServices().map(
            (service) => {

              const full_amount = service.price_per_unit * this.getItemSlotsList(service.id).duration * this.getSlots(service.id)
              const discount_size = full_amount * this.getDiscount(service.id) / 100

              return {
                service_id: service.id,

                subscription_start_date: this.getStartDate(service.id),
                subscription_finish_date: this.getFinishDate(service),

                period: this.getItemSlotsList(service.id).duration,
                user_id: this.USER_ID,

                price_per_unit: service.price_per_unit,
                discount_size: discount_size,
                discount_percent: this.getDiscount(service.id),
                full_amount: full_amount,

                unit_count: this.getSlots(service.id),

                slots: this.getItems(service.id)
              }
            }
        )

      };
      topUp(data.amount, this.USER_ID, data.services).then(
          (response) => {
            window.location = response.data.url
          }
      )

    },
  }
}
</script>

<template>
  <div>
    <div class="awaiting" v-if="createInvoice">
      <p>Выписываем счет по указанным реквизитам.</p>
    </div>
    <div class="ais24--subscription">
      <div class="ais24--container">
        <div class="ais24--steps">
          <ul class="ais24--steps__list">
            <li class="ais24--steps__item" :class="getStep() === 0 ? ' active': ''">Подписка на сервисы</li>
            <li class="ais24--steps__item" :class="getStep() === 1 ? ' active': ''">Детали подписки</li>
            <li class="ais24--steps__item" :class="getStep() === 2 ? ' active': ''">Оплата</li>
          </ul>
        </div>
        <header class="ais24--header">
          <h2 class="ais24--title">Оплата</h2>
        </header><!--/.ais24--header-->
        <div class="ais24--details">
          <div class="ais24--details__content">
            <div class="ais24--payment ais24--selected-subscriptions-card">
              <fieldset class="ais24--fieldset">
                <legend class="ais24--fieldset__legend">Выберите способ оплаты</legend>
                <div class="ais24--fieldset__inner">
                  <div class="ais24--field-radio-group ais24--field-radio-group--vertical">
                    <div class="ais24--field-radio">
                      <label class="ais24--field-radio__label">
                        <input class="ais24--field-radio__input" type="radio" name="payment-method"
                               v-model="income_source"
                               value="card">
                        <span class="ais24--field-radio__caption">Банковской картой</span>
                      </label>
                    </div>
                    <div class="ais24--field-radio">
                      <label class="ais24--field-radio__label">
                        <input class="ais24--field-radio__input" type="radio" name="payment-method"
                               v-model="income_source"
                               value="bank">
                        <span class="ais24--field-radio__caption">Безналичная оплата</span>
                      </label>
                    </div>
                  </div>
                </div>
              </fieldset>
              <template v-if="income_source === 'bank'">
                <fieldset class="ais24--fieldset">
                  <legend class="ais24--fieldset__legend">Введите реквизиты</legend>

                  <div class="ais24--fieldset__inner">
                    <div class="ais24--field-number">

                      <label class="ais24--field-number__label">ИНН</label>
                      <v-text-field
                          ref="client_inn"
                          required
                          :rules="[v => !!v || 'Поле обязательно к заполнению']"
                          flat
                          solo
                          class="ais24--field-number__input"
                          :hide-details="validates.client_inn"
                          hide-spin-buttons
                          single-line
                          variant="plain"
                          label="Введите ИНН"
                          v-model="invoice.client_inn"
                          @blur="validate('client_inn')"
                          @keyup="searchInvoiceDetails"
                      >
                      </v-text-field>

                    </div>
                    <div v-if="requisites.length" class="requisites">
                      <label class="ais24--field-number__label">Вы ранее использовали следующие реквизиты, можете
                        выбрать
                        из них:</label>
                      <span v-for="offer in offers" v-bind:key="offer.id" class="requisite" @click="fill(offer)">
                      {{ offer.name }}<br/>
                      ИНН: {{ offer.inn }}<br/>
                      Наименование банка: {{ offer.bank_name }}, счет: {{ offer.checking_account }}
                    </span>
                    </div>

                    <div class="ais24--field-text">
                      <label class="ais24--field-text__label">Наименование юридического лица</label>

                      <v-text-field
                          ref="client_name"
                          required
                          :rules="[v => !!v || 'Поле обязательно к заполнению']"
                          flat
                          solo
                          class="ais24--field-number__input"
                          :hide-details="validates.client_name"
                          hide-spin-buttons
                          single-line
                          variant="plain"
                          v-model="invoice.client_name"
                          @blur="validate('client_name')"
                      ></v-text-field>
                    </div>
                    <div class="ais24--field-number">
                      <label class="ais24--field-number__label">Наименование банка</label>
                      <v-text-field
                          ref="client_bank_name"
                          required
                          :rules="[v => !!v || 'Поле обязательно к заполнению']"
                          flat
                          solo
                          class="ais24--field-number__input"
                          :hide-details="validates.client_bank_name"
                          hide-spin-buttons
                          single-line
                          variant="plain"
                          v-model="invoice.client_bank_name"
                          @blur="validate('client_bank_name')"
                      ></v-text-field>
                    </div>
                    <div class="ais24--field-number">
                      <label class="ais24--field-number__label">БИК</label>
                      <v-text-field
                          ref="client_bik"
                          required
                          :rules="[v => !!v || 'Поле обязательно к заполнению']"
                          flat
                          solo
                          class="ais24--field-number__input"
                          :hide-details="validates.client_bik"
                          hide-spin-buttons
                          single-line
                          variant="plain"
                          v-model="invoice.client_bik"
                          @blur="validate('client_bik')"
                      ></v-text-field>
                    </div>
                    <div class="ais24--field-number">
                      <label class="ais24--field-number__label">Корр. счёт</label>
                      <v-text-field
                          required
                          ref="client_ks"
                          :rules="[v => !!v || 'Поле обязательно к заполнению']"
                          flat
                          solo
                          class="ais24--field-number__input"
                          :hide-details="validates.client_ks"
                          hide-spin-buttons
                          single-line
                          variant="plain"
                          v-model="invoice.client_ks"
                          @blur="validate('client_ks')"
                      ></v-text-field>
                    </div>
                    <div class="ais24--field-number">
                      <label class="ais24--field-number__label">Расчётный счёт</label>
                      <v-text-field
                          required
                          ref="client_rs"
                          :rules="[v => !!v || 'Поле обязательно к заполнению']"
                          flat
                          solo
                          class="ais24--field-number__input"
                          :hide-details="validates.client_rs"
                          hide-spin-buttons
                          single-line
                          variant="plain"
                          v-model="invoice.client_rs"
                          @blur="validate('client_rs')"
                      ></v-text-field>
                    </div>
                    <div class="ais24--field-number">
                      <label class="ais24--field-number__label">Адрес</label>
                      <v-text-field
                          required
                          ref="client_legal_address"
                          :rules="[v => !!v || 'Поле обязательно к заполнению']"
                          flat
                          solo
                          class="ais24--field-number__input"
                          :hide-details="validates.client_legal_address"
                          hide-spin-buttons
                          single-line
                          variant="plain"
                          v-model="invoice.client_legal_address"
                          @blur="validate('client_legal_address')"
                      ></v-text-field>
                    </div>
                  </div>
                </fieldset>
                <fieldset class="ais24--fieldset">
                  <div class="ais24--fieldset__inner">
                    <div class="ais24--field-checkbox ais24--field-checkbox--default">
                      <label class="ais24--field-checkbox__label">
                        <input class="ais24--field-checkbox__input" type="checkbox" checked>
                        <div class="ais24--field-checkbox__title">
                          <div class="ais24--field-checkbox__caption">Запомнить данные для дальнейших оплат</div>
                        </div>
                      </label>
                    </div>
                  </div>
                </fieldset>
              </template>
              <template v-else>
                <fieldset class="ais24--fieldset">
                  <!-- CARD -->
                </fieldset>
              </template>

            </div><!--/.ais24--payment-->
          </div><!--/.ais24--details__content-->
          <aside class="ais24--details__sidebar">
            <div class="ais24--calculation">
              <header class="ais24--calculation-header">
                <h3 class="ais24--calculation-header__title">Расчет стоимости:</h3>
              </header><!--/.ais24--calculation-header-->
              <div class="ais24--calculation-body">
                <div class="ais24--calculation-card" v-for="service in getServices()" v-bind:key="service.id">
                  <div class="ais24--calculation-card__caption">Сервис</div>
                  <ul class="ais24--calculation-card__list">
                    <li class="ais24--calculation-card__item">
                      <strong class="ais24--calculation-card__title">{{ service.name }}</strong>
                      <span class="ais24--calculation-card__info">{{ service.price_per_unit }} ₽/мес. за 1 место</span>
                    </li>
                    <li class="ais24--calculation-card__item">
                      <strong class="ais24--calculation-card__title">Период подписки:</strong>
                      <span class="ais24--calculation-card__info">{{
                          getItemSlotsList(service.id).duration
                        }} мес. (c {{ getStartDate(service.id) }} до {{ getFinishDate(service) }})</span>
                    </li>
                    <li class="ais24--calculation-card__item">
                      <strong class="ais24--calculation-card__title">{{ getSlots(service.id) }} места
                        организации:</strong>
                      <span class="ais24--calculation-card__info">{{
                          service.price_per_unit
                        }} ₽ &times; {{ getItemSlotsList(service.id).duration }} мес. &times; {{ getSlots(service.id) }} слот. =
                      <template v-if="getDiscount(service.id)">
                      <s>{{
                          getItemSlotsList(service.id).duration * service.price_per_unit * getSlots(service.id)
                        }} ₽</s>
                                                <strong>{{
                                                    getItemSlotsList(service.id).duration * service.price_per_unit * getSlots(service.id) * (100 - getDiscount(service.id)) / 100
                                                  }} ₽</strong>
                        </template>
                        <template v-else>
                          <strong>{{
                              getItemSlotsList(service.id).duration * service.price_per_unit * getSlots(service.id)
                            }} ₽</strong>
                        </template>
                                            </span>
                      <span class="ais24--calculation-card__discount"
                            v-if="getDiscount(service.id)">{{ getDiscount(service.id) }}% скидка</span>
                    </li>
                  </ul>
                </div><!--/.ais24--calculation-card-->
              </div><!--/.ais24--calculation-body-->
              <footer class="ais24--calculation-footer">
                <div class="ais24--calculation-total">
                  <div class="ais24--calculation-total__text">Итого к оплате:</div>
                  <div class="ais24--calculation-total__price">{{ getSum }}&nbsp;₽</div>
                </div><!--/.ais24--calculation-total-->
                <div class="ais24-calculation-action">
                  <button class="ais24--button ais24--button--primary ais24--button--large" type="button"
                          :disabled="getSum === 0"
                          v-if="income_source === 'bank'" @click="getInvoice">
                    <span class="ais24--button__text">Выставить счёт</span>
                  </button>
                  <button class="ais24--button ais24--button--primary ais24--button--large" type="button"
                          :disabled="getSum === 0"
                          v-if="income_source === 'card'" @click="payWithCard">
                    <span class="ais24--button__text">Перейти к оплате</span>
                  </button>
                </div><!--/.ais24-calculation-action-->
              </footer><!--/.ais24--calculation-footer-->
            </div><!--/.ais24--calculation-->
          </aside><!--/.ais24--details__sidebar-->
        </div>
      </div><!--/.ais24--container-->
      <div class="ais24--actions-bar">
        <div class="ais24--container">
          <div class="ais24--actions-bar-holder">
            <div class="ais24--actions-bar-holder__previous">
              <router-link class="ais24--button ais24--button--outline ais24--button--large"
                           :to="{name: 'SubscriptionDetailsPage'}">
                <span class="ais24--button__text">Назад</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped lang="scss">
.ais24--dialog .ais24--dialog-body {
  flex: auto;
}

.awaiting {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 200;
  background: rgba(0, 0, 0, 0.9);
  color: #fff;

  p {
    margin: 30px;
  }
}


.requisites {
  span:first-child {
    border-radius: 10px 10px 0 0;
    border-bottom: 0;
  }

  .requisite {
    display: block;
    padding: 10px;
    border: 1px solid #ccc;
    cursor: pointer;
    border-bottom: 0;

    &:hover {
      background: #f0f0f0;
    }
  }

  span:last-child {
    border-radius: 0 0 10px 10px;
    border: 1px solid #ccc;
  }
}
</style>
